module.exports = __webpack_public_path__ + "static/media/reddit.02369510.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/reddit.svg
// module id = 467
// module chunks = 0